// Settings
export const SETTINGS = '/settings';
export const GET_SETTINGS = '/settings/';
export const DELETE_SETTINGS = '/settings';
export const ADD_SETTINGS = '/settings/';
export const UPDATE_SETTINGS = '/settings';
export const BASE_SETTINGS_COLOR = '/settings/base/color';
export const BASE_SETTINGS_LOGIN = '/settings/base/logo/login';
export const BASE_SETTINGS_HEADER = '/settings/base/logo/header';

//Modules
export const GET_MODULES = '/module/';
export const GET_MODULE = '/module/';
export const ADD_MODULE = '/module/';
export const UPDATE_MODULE = '/module';
export const DELETE_MODULE = '/module';

export const MODULE_ESTABLISHMENT = '/module_establishment';
export const GET_MODULE_ESTABLISHMENT = '/module_establishment/';
export const DELETE_MODULE_ESTABLISHMENT = '/module_establishment';
export const ADD_MODULE_ESTABLISHMENT = '/module_establishment/';
export const UPDATE_MODULE_ESTABLISHMENT = '/module_establishment';

//Payment
export const PAYMENT = '/payment';
export const GET_PAYMENT = '/payment/';
export const DELETE_PAYMENT = '/payment';
export const ADD_PAYMENT = '/payment/';
export const UPDATE_PAYMENT = '/payment';
export const ADD_PAYMENT_CANCELLED = '/payment/cancelled/';
export const GENERATE_PAYMENT = '/payment/generate';
export const PREVIEW_PAYMENT = '/payment/preview';

// Module usage facts
export const GET_MODULE_USAGE_FACT = '/module_usage_fact/';
export const CALCULATE_MODULE_USAGE_FACT = '/module_usage_fact/calculate';
